import MobileLandingLayout from "./MobileLandingLayout";
export default MobileLandingLayout;
